import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { Pref, PrefTypeRequest, SettingsState } from "@/store/settings/types";
import { RootState } from "../types";
import Vue from "vue";

export const actions: ActionTree<SettingsState, RootState> = {
	async loadAllPrefTypes({ commit }) {
		const { data } = await api.loadAllPrefTypes();
		commit("setAllPrefTypes", data);
	},
	async loadAllIcons({ commit }) {
		const { data } = await api.loadAllIcons();
		commit("setAllIcons", data);
	},
	async loadAllPrefs({ commit }) {
		const { data } = await api.loadAllPrefs();
		commit("setAllPrefs", data);
	},
	async loadAllGroups({ commit }) {
		const userGroups = await api.loadUserGroups();
		commit("setAllGroups", userGroups);
	},
	async loadGroup({ commit }, groupID: number) {
		const group = await api.loadGroup(groupID);
		commit("setSelectedGroup", group);
	},

	async updatePref({ commit }, pref: Pref) {
		const res = await api.updatePref(pref);
		if (res.status == 200 || res.status == 204) {
			Vue.prototype.$notify({
				type: "success",
				title: "Successfully Updated",
				text: "Settings was successfully updated."
			});
		}
	},

	async createPref({ commit }, pref: Pref) {
		const res = await api.createPref(pref);
		if (res.status == 200 || res.status == 201) {
			Vue.prototype.$notify({
				type: "success",
				title: "Successfully Created",
				text: "Settings was successfully created."
			});
		}
	},

	async getPrefsFromList({ commit }, prefRequestList: PrefTypeRequest[]) {
		const prefList = await api.getPrefsFromList(prefRequestList) || [];
		let unavilablePrefErrors = [
			"This pref is not publicly available and you do not have the permissions to see all prefs, please configure the data service.",
			"This pref is not anonymously available and you do not have the permissions to see all prefs, please configure the data service."
		];

		commit("mergePrefs", prefList.filter((pref: Pref) => !unavilablePrefErrors.includes(pref.value)));
	}
};
